// extracted by mini-css-extract-plugin
export default {"adminContainer":"AdminDashboard_adminContainer__3w3z1","sidebar":"AdminDashboard_sidebar__5GhSJ","active":"AdminDashboard_active__L9iO7","content":"AdminDashboard_content__yWmhF"};